module.exports = __webpack_public_path__ + "img/file-indd.d9e2c86e.svg";